<template>
  <yxt-table
    ref="multipleTable"
    :data="data"
    :tree-props="treeProps"
    :row-key="rowKey"
    :expand-row-keys="expandRowKeys"
    :default-expand-all="defaultExpandAll"
    class="customized-table"
    :height="height"
    :max-height="maxHeight"
  >
    <yxt-table-column
      :width="columnWidth"
      :show-overflow-tooltip="true"
      prop="name"
      class-name="customize-table-column"
      :label="$t(columnLabel)"
    >
      <template slot-scope="scope">
        <template
          v-if="selection && (!scope.row[treeProps.children] || scope.row[treeProps.children].length ===0)"
        >
          <!-- subitem checked style use radio style when radio model is on -->
          <div
            v-if="radioModel && data.findIndex(item => item[rowKey] === scope.row[rowKey]) === -1"
            class="flex align-items-center"
            @click="switchSelected(selected.findIndex(sel => sel[rowKey] === scope.row[rowKey]) === -1,scope.row)"
          >
            <yxt-svg
              v-if="getCheckStatus(scope.row)"
              width="16px"
              height="16px"
              class="mr16 hand color-primary"
              :class="{disabled: getDisabledStatus(scope.row)}"
              :remote-url="gwnlMediaDomain + '/gwnl/pc/svg'"
              icon-class="checked2"
            />
            <yxt-radio
              v-else
              class="customized-radio mb3"
              :value="false"
              :disabled="getDisabledStatus(scope.row)"
            />
          </div>
          <yxt-checkbox
            v-else
            :disabled="getDisabledStatus(scope.row)"
            :name="scope.row[rowKey]"
            :value="getCheckStatus(scope.row)"
            class="customized-checkbox"
            @change="checked=>switchSelected(checked,scope.row)"
          />
        </template>
        <span class="">{{ scope.row.name }}</span>
        <slot
          name="nameSuffix"
          :row="scope.row"
        />
        <yxt-svg
          v-if="scope.row[treeProps.children] && getCheckboxValue(scope.row)"
          width="20px"
          height="20px"
          :remote-url="gwnlMediaDomain + '/gwnl/pc/media/images/pc_svg/position'"
          icon-class="check"
          class="ml8"
        />
      </template>
    </yxt-table-column>
    <slot />
  </yxt-table>
</template>

<script>

export default {
  props: {
    columnLabel: {
      type: String,
      default: 'pc_biz_gwnl_global_lbl_title'
    },
    rowKey: [String, Function],
    columnWidth: {
    },
    selection: {
      type: Boolean,
      default: false
    },
    expandRowKeys: Array,

    defaultExpandAll: Boolean,
    data: {
      type: Array,
      default: function() {
        return [];
      }
    },
    treeProps: {
      type: Object,
      default() {
        return {
          hasChildren: 'hasChildren',
          children: 'children'
        };
      }
    },
    disabledList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 同一层级下面只能选中一个
    radioModel: {
      type: Boolean,
      default: false
    },
    selectedList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    height: {
      type: Number
    },
    maxHeight: {
      type: Number
    }
  },
  data() {
    return {
      selected: []
    };
  },
  computed: {
    gwnlMediaDomain() {
      return this.$staticBaseUrl + 'ufd/c4d5f9';
    }
  },
  watch: {
    selectedList: {
      immediate: true,
      handler: function(val) {
        this.selected = val;
        this.setSelectedInTable();
      }
    }
  },
  methods: {
    getCheckStatus(row) {
      return this.selected.findIndex(sel => sel[this.rowKey] === row[this.rowKey]) > -1;
    },
    getCheckboxValue(row) {
      return this.recursionCheck(row);
    },
    recursionCheck(row) {
      if (!row[this.treeProps.children]) {
        return this.selected.findIndex(sel => sel[this.rowKey] === row[this.rowKey]) > -1;
      }
      return row[this.treeProps.children].some(item => this.recursionCheck(item));
    },
    getIndeterminateStatus(row) {
      const children = row[this.treeProps.children];
      if (children) {
        const checkedItem = children.filter(item => this.selected.findIndex(sel => sel[this.rowKey] === item[this.rowKey]) > -1);
        return checkedItem.length > 0 && checkedItem.length < children.length;
      } else {
        return false;
      }
    },
    getDisabledStatus(row) {
      if (this.disabled) {
        return true;
      }
      const inDisabledList = this.disabledList.findIndex(disItem => disItem[this.rowKey] === row[this.rowKey]) > -1;
      if (this.radioModel) {
        return inDisabledList;
      }
      const isChecked = this.getCheckboxValue(row);
      return inDisabledList && !isChecked;
    },
    switchSelected(checked, row) {
      if (this.getDisabledStatus(row)) {
        return;
      }
      if (checked) {
        if (this.radioModel) {
          const parent = this.data.find(item => item[this.treeProps.children] && item[this.treeProps.children].findIndex(sub => sub[this.rowKey] === row[this.rowKey]) > -1);
          parent && parent[this.treeProps.children].forEach(it => {
            this.selected = this.selected.filter(item => item[this.rowKey] !== it[this.rowKey]);
          });
        }
        this.selected.push(row);
      } else {
        this.selected = this.selected.filter(item => item[this.rowKey] !== row[this.rowKey]);
      }
      this.$emit('selection-change', this.selected.filter(item => this.disabledList.findIndex(it => it[this.rowKey] === item[this.rowKey]) === -1), row);
    },
    setSelectedInTable() {
      this.selected.forEach(item => {
        this.$refs.multipleTable && this.$refs.multipleTable.toggleRowSelection(item, true);
      });
    },
    filteredTree() {
      return this.data.reduce(this.recursionFind, []);
    },
    recursionFind(result, current) {
      if (!current[this.treeProps.children] && this.selected.findIndex(sel => sel[this.rowKey] === current[this.rowKey]) > -1) {
        result.push(current);
        return result;
      }
      if (Array.isArray(current[this.treeProps.children])) {
        const nodes = current[this.treeProps.children].reduce(this.recursionFind, []);
        if (nodes.length) result.push({ ...current, [this.treeProps.children]: nodes });
      }
      return result;
    },
    flatTree(tree = []) {
      return tree.flatMap(item => {
        return this.recursionFlat(item);
      });
    },
    recursionFlat(arr) {
      if (!arr[this.treeProps.children]) {
        return [arr];
      }
      return arr[this.treeProps.children].flatMap(item => this.recursionFlat(item));
    },
    doLayout() {
      this.$refs.multipleTable && this.$refs.multipleTable.doLayout();
    }
  }
};
</script>

<style lang="scss" scoped>
.customized-checkbox {
  &.yxt-checkbox:last-of-type {
    margin-right: 8px;
  }
}

.customized-radio {
  ::v-deep .yxt-radio__label {
    padding-left: 16px;
  }
}

.disabled {
  color: #d9d9d9;
  cursor: not-allowed;
}
</style>
